import { render, staticRenderFns } from "./UnknownTypeBIReport.vue?vue&type=template&id=1a83b586"
import script from "./UnknownTypeBIReport.vue?vue&type=script&lang=js"
export * from "./UnknownTypeBIReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports